import axios from "axios";
import router from "@/router"
import config from "@/common/config"

import {message} from 'ant-design-vue'

let urlCount = 0,
  loadServeice;
let delLoad = loadTimer => {
  clearTimeout(loadTimer);
  if (urlCount) urlCount--;
  if (!urlCount) {
    loadServeice && loadServeice.close();
    loadServeice = null;
  }
};
let errMessage = (text, type) => {
  setTimeout(() => message({
    showClose: true,
    message: text,
    type: type || 'error'
  }), 0)
}
let BASE_URL = config.BASE_URL;

export default ({
  url,
  data = {},
  options = {}
}) => {
  let {
    method = 'post',
    loadOpts = {},
    json = 0,
  } = options,

    postdata = '',
    params = {},
    token = localStorage.getItem('t') || '',
    hostname = 'webapp';

    url = (() => {
      return BASE_URL + url
    })();
    data = {
      ...data
    }

  let axiosConfig = {
    timeout: 10000,
    headers: {
      'Content-Type': json ? 'application/json' : 'application/x-www-form-urlencoded',
      'token': token,
      'hostname': hostname
    },
  };
  const instance = axios.create(axiosConfig);
  instance.interceptors.request.use(
    config => {
      return config;
    },
    error => Promise.reject(error)
  );

  instance.interceptors.response.use(
    response => {
      return response;
    },
    error => Promise.reject(error)
  );

  return new Promise((resolve, reject) => {
    
    if (json) {
      postdata = JSON.stringify(data);
    } else {
      let dataArr = [];
      for (let key in data) {
        let d = data[key];
        d = Array.isArray(d) ?
          encodeURIComponent(d.join(",")) :
          encodeURIComponent(d);
        dataArr.push(key + "=" + d);
      }
      postdata = dataArr.join("&");
    }
    if (method === 'post' || json || method === 'put') {
      params = {
        method,
        url,
        data: postdata
      }
    } else {
      params = {
        method,
        url: url + '?' + postdata
      }
    }
    return instance(params).then((res) => {
      let {
        data,
        headers
      } = res;

      if (data.code === 200 ) {
        resolve(data.data);
      } 
      else if (data.code === 0) {
        message.warning(data.msg);
        resolve(data.data);
      }
      else {
        message.warning(data.msg);
        reject(data);
      }

    }).catch(err => {

      
      if (err.response.status === 499) {
        
        router.replace({
          name: 'Login'
        })

      }
      else if (err.response.status === 422) {
        message.warning('请输入必填项');
      }
      else {
        message.error('服务出错，请稍后重试');
      }

      reject(err);
    })
  })
}
